import React from 'react'
import './MakroCartModal.scss'
import { Modal, useMediaQuery } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'

import { ReactComponent as CloseIcon } from '../../components/assets/MakroPage/CloseModal.svg'
import { ReactComponent as ExportIcon } from '../../components/assets/MakroPage/ExportIcon.svg'
import MakroCartItem from './MakroCartItem/MakroCartItem'
import { setClearCart } from '../../../store/slices/allItemsCart'
import { useNavigate, useParams } from 'react-router'
import MakroInvoiceTemplate from '../MakroInvoiceTemplate/MakroInvoiceTemplate'
import { PDFDownloadLink } from '@react-pdf/renderer'

const MakroCartModal = ({open=false, onClose=()=>{}, sx={}}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const mobileView = useMediaQuery('(max-width: 798px)')
  const tradeName = useParams().tradeName

  const allItemsCart = useSelector((state) => state.allItemsCart.allItemsCart);

  const cartItems = allItemsCart?.filter((item) => item?.sku?.includes('MCH'))?.sort((a, b) => a?.name?.localeCompare(b?.name))

  const total = cartItems?.reduce((acc, curr) => acc + curr?.spoPrice * (curr?.quantity || 0), 0)
  const totalWithoutVAT = cartItems?.reduce((acc, curr) => acc + (curr?.spoPrice * (curr?.quantity || 0)/(1 + curr?.IVA / 100)), 0)

  const handleClearCart = () => {
    dispatch(setClearCart())
  }
  
  // Заглушки для кнопок Pay и Export (добавьте логику позже)
  const handlePay = () => {
    navigate('/newOrder/'+tradeName)
  }  

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
    >
      <div
        className='MakroCartModal'
        style={{
          ...sx,
          width: mobileView ? '100vw' : '450px',
          height: mobileView ? '100dvh' : '90dvh',  
          left: mobileView ? 0 : '50%',
          top: mobileView ? 0 : '50%',
          position: mobileView ? 'absolute' : 'fixed',
          transform: mobileView ? '' : 'translate(-50%, -50%)',
        }}
      >
        <div className="head">
          <span>Cart ({allItemsCart?.length || 0})</span>
          <p><CloseIcon onClick={() => onClose()}/></p>
        </div>
        {allItemsCart?.length > 0 && <div className="action">
          <PDFDownloadLink 
            document={
              <MakroInvoiceTemplate 
                cartItems={cartItems} 
                total={total} 
                totalWithoutVAT={totalWithoutVAT} 
                tradeName={tradeName} 
              />
            } 
            fileName={`invoice_${tradeName}.pdf`}
            style={{ textDecoration: 'none' }}
          >
            {({ loading }) => (
              <button disabled={loading}>
                <ExportIcon /> {loading ? 'Preparing...' : 'Export cart'}
              </button>
            )}
          </PDFDownloadLink>
        </div>}
        <div className="container">
          {cartItems?.map((el) => (
            <MakroCartItem item={el} key={el?.sku}/>
          ))}
          {(!allItemsCart || allItemsCart.length === 0) && (
             <div style={{textAlign: 'center', color: '#888', fontSize: '14px', width: '100%', marginTop: '40px'}}>
                Your cart is empty
             </div>
          )}
        </div>
        {allItemsCart?.length > 0 && (
          <div className="total">
            <div className="rw">
              <span
                onClick={handleClearCart}
                className='clear'
              >Clear all</span>
            </div>
            <div className="cl">
              <div className="rw">
                <span className='label'>Cart value net</span>
                <span className='value'>€{totalWithoutVAT?.toFixed(2)}</span>
              </div>
              <div className="rw">
                <span className='label'>Cart value net + TPO(16%)</span>
                <span className='value'><b>€{total?.toFixed(2)}</b></span>
              </div>
            </div>
            <button
              onClick={handlePay}
              className='pay'
            >Pay</button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default MakroCartModal